import { Duration } from 'luxon';

export const formatDuration = (duration: {
  toMillis: () => number;
}): string => {
  const parsed = Duration.fromMillis(Math.max(0, duration.toMillis())).shiftTo(
    'hours',
    'minutes',
  );
  const hours = Math.floor(parsed.hours);
  const minutes = Math.floor(parsed.minutes);

  if (hours && minutes) return `${hours} h ${minutes} min`;
  if (hours) return `${hours} h`;
  if (minutes) return `${minutes} min`;
  return 'less than 1 min';
};

export const formatPeople = (people: number): string => {
  if (people < 1) return 'none';
  if (people >= 5) return 'many';
  return String(people);
};

export const formatDurationBetween = (start: Date, end: Date): string => {
  return formatDuration(
    Duration.fromMillis(Math.max(0, end.getTime() - start.getTime())),
  );
};
